import React, {useState} from 'react';
import {createRender} from 'react-render-callback';

import {FormContext} from 'iss/widgets/form/FormContext';

export {FormContext} from 'iss/widgets/form/FormContext';
export {FormSection} from 'iss/widgets/form/FormSection';
export {Field, formComponent, selectorFormComponent} from 'iss/widgets/form/Field';
export * from 'iss/widgets/form/Inputs';
export * from 'iss/widgets/form/input/DateInputs';
export {Select} from 'iss/widgets/form/input/Select';

/** Wraps a html form element into a FormContext (see form/FormContext)
 * for automatic handling of form values, validation and submitting.
 *
 * Props:
 *
 * values: the values this form operates on.
 * valueUpdater: a function that when given a transformer function from values to
 *               new values updates the state provided in the values prop.
 * onSubmit: callback to fire on succesful form submit. Is given the current values and form API as a parameters.
 * onError: callback to fire on invalid form submit. Is given the current values and form API as a parameters.
 * children: Normal children or a callback function that takes the values and formApi as parameters
 */
export function Form({children, values, valueUpdater, onSubmit, ...props}) {
  return <FormContext values={values} valueUpdater={valueUpdater} onSubmit={onSubmit}>
    {(values, formApi) =>
      <form onSubmit={formApi.submit} {...props}>
        {createRender(children)(values, formApi)}
      </form>
    }
  </FormContext>;
}

/** A version of Form above that handles the state updating logic for you.
 * Should be supplied initial values in the form of the prop initialValues
 */
export function FormWithState({initialValues, ...props}) {
  const [values, valueUpdater] = useState(initialValues);
  return <Form values={values} valueUpdater={valueUpdater} {...props} />;
}




// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/Forms.jsx